/**
 * Text constants for Link.
 * @readonly
 */
export const AGENCY_ID = '~agency_id' as const;
export const BRANCH_AD_FORMAT = '~branch_ad_format' as const;
export const FEATURE = '~feature' as const;
export const PAID_ADVERTISING = 'paid advertising' as const;
export const OS_TYPE = '~os_type' as const;
export const AD_LINK_TEMPLATE_ID = '~link_template_id' as const;
